<template>
  <div>
    <div class="profileClassFirst">
      <main class="profile">
        <div class="profile-bg"></div>

        <section class="container1">
          <Skeletor
            v-if="LoadingSkeleton"
            class="profile-image profileImageSkeletor"
            style="border-radius: 30px; background: rgb(163, 219, 213)"
          />

          <figure v-if="!LoadingSkeleton" class="profile-image">
            <img
              :src="
                $store.state.auth.role == 'branch_admin'
                  ? branch_infos?.avatar || '/img/amlakLogo.jpg'
                  : branch_infos?.user_avatar || '/img/amlakLogo.jpg'
              "
              @error="onImgError"
              :alt="branch_infos?.title"
            />
            <div class="addStoryBtn" @click="storyOpenHandler">
              <VsxIcon iconName="Add" :size="32" color="#fff" type="linear" />
            </div>
            <div class="gradient" v-if="userStory.length !== 0"></div>
            <div
              class="storyToggleBtn"
              v-if="userStory.length !== 0"
              @click="openDialog"
            ></div>
          </figure>

          <section
            class="profile-info"
            :class="{ infoSkeleton: LoadingSkeleton }"
          >
            <Skeletor
              v-if="LoadingSkeleton"
              class="first-name firstNameSkeletor"
              style="
                width: 50%;
                position: absolute;
                top: -80px;
                right: 20px;
                height: 50px;
                border-radius: 10px;
                background: rgb(163, 219, 213);
              "
            />
            <h1
              v-if="!LoadingSkeleton && $store.state.auth"
              class="first-name"
              :class="{
                consultantBranch: $store.state.auth.role == 'consultant',
              }"
            >
              {{ branch_infos?.title }}
            </h1>

            <div
              v-if="!LoadingSkeleton && $store.state.auth.role == 'consultant'"
              class="PhoneClassNumber addressProfile"
            >
              <p>مباشر :</p>
              <span>{{ branch_infos?.user_nickname }} </span>
            </div>

            <Skeletor
              v-if="LoadingSkeleton"
              style="
                height: 46px;
                border-radius: 10px;
                background: rgb(163, 219, 213);
              "
            />

            <div
              v-if="!LoadingSkeleton && $store.state.auth"
              class="PhoneClassNumber"
              :class="{
                addressProfile: $store.state.auth.role == 'consultant',
              }"
            >
              <p>شماره همراه :</p>
              <span>{{ $store.state.auth.mobile }}</span>

              <VsxIcon
                class="LogoutCurve1 profileLogoutCurve"
                @click="profileEditHadler"
                iconName="UserEdit"
                :size="32"
                color="#0077b6"
                type="linear"
              />
              <VsxIcon
                class="LogoutCurve"
                @click="Logout()"
                iconName="LogoutCurve"
                :size="32"
                color="red"
                type="linear"
              />
            </div>

            <Skeletor
              v-if="LoadingSkeleton"
              class="PhoneClassNumber phoneclassSkeletor"
              style="
                height: 46px;
                border-radius: 10px;
                margin-bottom: 14px;
                background: rgb(163, 219, 213);
              "
            />

            <div
              v-if="!LoadingSkeleton"
              class="PhoneClassNumber addressProfile"
            >
              <p>آدرس :</p>
              <span>{{ branch_infos?.address }} </span>
            </div>

            <Skeletor
              v-if="LoadingSkeleton"
              class="PhoneClassNumber creditSign creditSignSkeletor"
              style="
                height: 40px;
                border-radius: 10px;
                margin-bottom: 8px;
                background: rgb(163, 219, 213);
              "
            />

            <div
              v-if="!LoadingSkeleton"
              class="PhoneClassNumber addressProfile creditSign"
            >
              <p>موجودی :</p>
              <span
                >{{ formatPrice($store.state.auth.credit) }}
                {{ $store.state.c_set.currency }}
              </span>
            </div>

            <div
              v-if="!LoadingSkeleton"
              class="PhoneClassNumber addressProfile requestVisit"
            >
              <p>ثبت درخواست بازدید :</p>
              <label
                class="switchInput"
                :class="{ loading: requestStatLaoing }"
              >
                <input
                  ref="visitStat"
                  type="checkbox"
                  v-model="visitStatChecked"
                  @change="handleToggle"
                />
                <span class="slider"></span>
              </label>
            </div>

            <Skeletor
              v-if="LoadingSkeleton"
              class="profileEditBtn profileEditBtnSkeletor"
              style="
                height: 48px;
                border-radius: 10px;
                background: rgb(163, 219, 213);
                margin-bottom: 8px;
              "
            />

            <div v-if="!LoadingSkeleton" class="mobileProfileBtns">
              <div class="profileEditBtn" @click="profileEditHadler">
                ویرایش پروفایل
                <VsxIcon
                  iconName="UserEdit"
                  :size="22"
                  color="#fff"
                  type="linear"
                />
              </div>
              <router-link
                v-if="$store.state.c_set && $store.state.c_set.credit_visible"
                to="/wallet"
                class="profileEditBtn addCreditbtn"
              >
                <span> افزایش اعتبار</span>
                <VsxIcon iconName="Add" :size="22" color="#fff" type="linear" />
              </router-link>
              <div class="logoutBtn" @click="Logout()">
                <i class="fa-solid fa-arrow-right-from-bracket"></i>
              </div>
            </div>
          </section>
          <Skeletor
            v-if="LoadingSkeleton"
            class="statistics mobileStatistics mobileStatisticsSkeletor"
            style="
              width: 95%;
              margin: auto;
              height: 50px;
              border-radius: 10px;
              background: rgb(163, 219, 213);
            "
          />

          <section v-if="!LoadingSkeleton" class="statistics mobileStatistics">
            <p @click="selectedFollowHandler('follower', true)">
              <strong>{{ $store.state.auth.follower }}</strong> دنبال‌کننده
            </p>
            <p @click="selectedFollowHandler('following', true)">
              <strong>{{ $store.state.auth.following }}</strong> دنبال‌شونده
            </p>
            <p @click="openComponent('ShowFile')">
              <strong v-if="branch_infos && branch_infos.post">{{
                branch_infos?.post
              }}</strong>
              <strong v-else>0</strong> فایل
            </p>
          </section>
        </section>

        <div v-if="LoadingSkeleton" class="desktopStatisticsWrapperSk">
          <Skeletor class="desktopStatisticsSk" />
          <Skeletor class="desktopStatisticsSk" />
          <Skeletor class="desktopStatisticsSk" />
        </div>

        <section v-if="!LoadingSkeleton" class="statistics desktopStatistics">
          <p @click="selectedFollowHandler('follower', true)" class="pointer">
            <strong>{{ $store.state.auth.follower }}</strong> دنبال‌کننده
          </p>
          <p @click="selectedFollowHandler('following', true)" class="pointer">
            <strong>{{ $store.state.auth.following }}</strong> دنبال‌شونده
          </p>
          <p @click="openComponent('ShowFile')">
            <strong>{{ branch_infos?.post }}</strong> فایل
          </p>
        </section>

        <Skeletor
          v-if="LoadingSkeleton"
          class="statistics desktopStatistics desktopAddCreditskeletor"
          style="
            width: 93%;
            margin: auto;
            margin-top: 0;
            height: 64px;
            border-radius: 10px;
            background: rgb(163, 219, 213);
          "
        />
        <section v-if="!LoadingSkeleton" class="desktopAddCreditBtnWrapper">
          <div class="addCreditLabel">
            <span>موجودی:</span>
            {{ formatPrice($store.state.auth.credit) }}
            {{ $store.state.c_set.currency }}
          </div>
          <router-link
            v-if="$store.state.c_set && $store.state.c_set.credit_visible"
            to="/wallet"
            class="desktopAddCreditBtn"
          >
            <span>افزایش اعتبار</span>
            <VsxIcon iconName="Add" :size="28" color="#fff" type="linear" />
          </router-link>
        </section>
      </main>

      <div class="ShowChildTemplate">
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />

        <div v-show="!LoadingSkeleton">
          <!--       CreateMelk   //////////-->
          <div
            @click="openComponent('myNotif')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Notification"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>اعلان های من</p>

            <div
              v-if="
                branch_infos && branch_infos.notify && branch_infos.notify > 0
              "
              class="notifNum"
            >
              {{ branch_infos.notify }}
            </div>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>
          <div
            @click="openComponent('CreateMelk')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon iconName="Add" :size="32" :color="color" type="linear" />
            <p>ثبت آگهی</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--         ShowFile //////////-->
          <div
            @click="openComponent('ShowFile')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Notepad"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>آگهی های من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>
          <div
            @click="openComponent('MyArchive')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Archive"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>بایگانی فایل ها</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>
          <!--        PhoneBook  //////////-->
          <div
            @click="openComponent('PhoneBook')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="CallAdd"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>مخاطبین من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--       NoteBook   //////////-->
          <div
            @click="openComponent('NoteBook')"
            class="ChildShowChildTemplate"
          >
            <VsxIcon iconName="House" :size="32" :color="color" type="linear" />
            <p>لیست متقاضیان</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--       CreateContract   //////////-->
          <div
            @click="openComponent('createContract')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Document"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>ثبت قراردادها</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>
          <div
            @click="openComponent('ShowRent')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Stickynote"
              :size="32"
              :color="color"
              type="linear"
            />

            <div class="AllShowCountList">
              <p>قراردادهای ثبت شده</p>
              <div class="ShowCountList">
                سررسید:
                <span class="listCount">{{ branch_infos?.show_rents }}</span>
              </div>
            </div>

            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--          MyAdvisors//////////-->
          <div
            v-if="$store.state.auth.role != 'consultant'"
            @click="openComponent('MyAdvisors')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Profile2User"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>مباشران من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--          MyAdvisors//////////-->
          <div
            @click="openComponent('VisitRequest')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Calendar"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>درخواست های بازدید</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
            <div
              v-if="currentUserInfo && currentUserInfo.post_visit_count != '0'"
              class="notifNum"
            >
              {{ currentUserInfo?.post_visit_count }}
            </div>
          </div>

          <!--      buySubscribtion    //////////-->
          <div
            v-if="
              $store.state.c_set &&
              $store.state.c_set.has_credit &&
              userTariff == null &&
              $store.state.c_set.eshterak_menu
            "
            @click="openComponent('buySubscribtion')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Buildings2"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>خرید اشتراک</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <div
            v-if="$store.state.c_set && $store.state.c_set.tariff_menu"
            @click="openComponent('userTariff')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="ReceiptEdit"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>
              {{
                $store.state.auth.role == "branch_admin"
                  ? "مدیریت تعرفه"
                  : "خرید تعرفه"
              }}
            </p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--      userSubscribtion    //////////-->
          <div
            v-if="userTariff != null"
            @click="openComponent('userSubscribtion')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon iconName="Crown" :size="32" :color="color" type="linear" />
            <p>اشتراک من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <myNotif
            @getBranchInfo="get_branch_info"
            @reloadComponnet="reloadComponent"
            v-if="left_menu.myNotif"
          ></myNotif>
          <create-melk v-if="left_menu.CreateMelk"></create-melk>
          <createContract
            @close="closeComponent('createContract')"
            v-if="left_menu.createContract"
            :BranchInfos="branch_infos"
          ></createContract>
          <show-file
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('ShowFile')"
            v-if="left_menu.ShowFile"
            :BranchInfos="branch_infos"
          ></show-file>
          <my-archive
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('MyArchive')"
            v-if="left_menu.MyArchive"
            :BranchInfos="branch_infos"
          ></my-archive>
          <show-rent
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('ShowRent')"
            v-if="left_menu.ShowRent"
            :BranchInfos="branch_infos"
          ></show-rent>
          <my-advisors
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('MyAdvisors')"
            v-if="left_menu.MyAdvisors"
          ></my-advisors>
          <buy-subscribtion
            @close="closeComponent('buySubscribtion')"
            @subscribtionBought="buySubscribtionHandler"
            v-if="left_menu.buySubscribtion"
          ></buy-subscribtion>
          <userTariff
            v-if="left_menu.userTariff"
            @close="closeComponent('userTariff')"
          ></userTariff>
          <userSubscribtion
            v-if="left_menu.userSubscribtion"
          ></userSubscribtion>
          <phone-book
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('PhoneBook')"
            v-if="left_menu.PhoneBook"
          ></phone-book>
          <note-book
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('NoteBook')"
            v-if="left_menu.NoteBook"
          ></note-book>
          <requestVisit
            @close="closeComponent('VisitRequest')"
            v-if="left_menu.VisitRequest"
          ></requestVisit>
          <!-- <contractArchive
            @filterStatus="(status) => (isFilterOpen = status)"
            @close="closeComponent('contractArchive')"
            v-if="left_menu.contractArchive"
            :BranchInfos="branch_infos"
          ></contractArchive> -->
        </div>
      </div>
    </div>

    <div
      @click="profileCloseHandler"
      v-if="ShowModel"
      role="dialog"
      class="j-modal"
      style="--padding-left: 0px; --padding-right: -17px"
    >
      <div @click.stop class="product-modal">
        <header class="product-modal-header">
          <p class="product-modal-header__title">ویرایش پروفایل</p>

          <div
            class="divCreateAdvisorsButton desktopEditBtn"
            v-if="!btn_loading"
            @click="send_edit_data()"
          >
            ویرایش
          </div>
          <div
            class="divCreateAdvisorsButton desktopEditBtn"
            style="cursor: not-allowed"
            v-if="btn_loading"
          >
            <span class="loader"></span>
            <span> ویرایش</span>
          </div>
          <div
            @click="profileCloseHandler"
            role="button"
            class="product-modal-header__close"
          ></div>
        </header>
        <div class="product-modal-content">
          <div class="product-modal-content__container">
            <el-scrollbar :style="editStyle" :max-height="editHeight">
              <div style="margin-bottom: 10px" class="ProfileSetCreate">
                <div id="imageBox" @click="openFileInput">
                  <input
                    type="file"
                    ref="fileInput"
                    accept="image/*"
                    @change="previewImage"
                    style="display: none"
                  />
                  <img
                    v-if="imageSrc"
                    :src="imageSrc"
                    id="imagePreview"
                    :alt="branch_info.title"
                  />
                  <img
                    v-if="!imageSrc"
                    :src="
                      $store.state.auth.role == 'branch_admin'
                        ? branch_infos.avatar
                        : branch_infos.user_avatar
                    "
                    id="imagePreview"
                    :alt="branch_info.title"
                  />
                  <button class="add-button">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div class="addPic_text">
                  انتخاب عکس پروفایل<span class="text-danger">*</span>
                </div>
              </div>

              <div class="ShowInputFormToUser1 profileEditForm">
                <div class="ChildShowInputFormToUser">
                  <label>نام<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="branch_info.fname"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>نام خانوادگی<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="branch_info.lname"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>نام املاک<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="branch_info.title"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>کد اتحادیه<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    maxlength="20"
                    v-model="branch_info.code"
                    inputmode="numeric"
                    @input="onlyNumbers($event, 'code')"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>کد ملی<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    maxlength="10"
                    v-model="branch_info.code_melli"
                    inputmode="numeric"
                    @input="onlyNumbers($event, 'code_melli')"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>منطقه<span class="text-danger">*</span></label>
                  <el-select v-model="branch_info.b_category_id" placeholder="">
                    <el-option
                      v-for="(v, i) in branch_list"
                      :key="i"
                      :value="v.id"
                      :label="v.title"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>شماره تماس<span class="text-danger">*</span></label>
                  <input
                    maxlength="11"
                    type="tel"
                    inputmode="numeric"
                    v-model="branch_info.mobile"
                    @input="onlyNumbers($event, 'mobile')"
                    disabled
                  />
                </div>

                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>تلفن تماس دفتر</label>

                  <input
                    type="tel"
                    maxlength="11"
                    inputmode="numeric"
                    v-model="branch_info.contact"
                    @input="onlyNumbers($event, 'contact')"
                  />
                </div>
                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس اینستاگرام</label>
                  <input
                    type="text"
                    v-model="branch_info.instagram"
                    style="direction: ltr; text-align: left"
                  />
                </div>
                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس تلگرام</label>
                  <input
                    type="text"
                    v-model="branch_info.telegram"
                    style="direction: ltr; text-align: left"
                  />
                </div>
                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس واتساپ</label>
                  <input
                    type="text"
                    v-model="branch_info.whatsup"
                    style="direction: ltr; text-align: left"
                  />
                </div>
                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="ChildShowInputFormToUser textareaWrapper"
                >
                  <label>درباره من</label>
                  <textarea
                    v-model="branch_info.description"
                    rows="2"
                  ></textarea>
                </div>
                <div
                  v-if="$store.state.auth.role != 'consultant'"
                  class="editMapContainer"
                >
                  <div class="containerLabel">
                    موقعیت مکانی مشاور<span class="text-danger">*</span>
                  </div>
                  <div class="containerMap">
                    <div id="map" class="leaflet-map"></div>
                  </div>
                  <div
                    v-if="$store.state.auth.role != 'consultant'"
                    class="ChildShowInputFormToUser"
                  >
                    <label>آدرس<span class="text-danger">*</span></label>
                    <input type="text" v-model="branch_info.address" />
                  </div>
                </div>
                <div class="resProfileEditBtn" @click="send_edit_data">
                  <span v-if="!btn_loading">ویرایش</span>
                  <span v-if="btn_loading" class="loader"></span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="j-modal__overly"></div>
    </div>

    <el-dialog
      v-model="showFollowed"
      align-center
      class="followListDialog"
      @close="selectedFollowClose"
    >
      <div class="followedList">
        <div class="followListNav">
          <div class="navTitle">
            <span v-if="selectedFollow == 'follower'">دنبال کنندگان</span>
            <span v-if="selectedFollow == 'following'">دنبال شوندگان</span>
          </div>
          <div class="navBackBtn">
            <div class="backBtn" @click="selectedFollowClose(true)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="followedListWrapper">
          <div class="headerWrapper">
            <div
              class="listHeader"
              :class="[selectedFollow == 'follower' ? 'follower' : 'following']"
            >
              <div class="headerSwitch"></div>
              <div
                class="headerBtn follower"
                :class="{ selected: selectedFollow == 'follower' }"
                @click="selectedFollowHandler('follower')"
              >
                دنبال کنندگان
              </div>
              <div
                class="headerBtn following"
                :class="{ selected: selectedFollow == 'following' }"
                @click="selectedFollowHandler('following')"
              >
                دنبال شوندگان
              </div>
            </div>
          </div>
          <div class="listContent">
            <!--            following-->
            <el-scrollbar
              v-show="selectedFollow == 'following'"
              class="usersList followingList"
              ref="followingList"
              :height="followListHeight"
            >
              <div v-if="following.loading && following.list.length === 0">
                <div v-for="n in 15" :key="n" class="skeleton-wrapper">
                  <div class="TopShowToUSerNAme">
                    <div class="ImageTopShowToUSerNAme"></div>
                    <div
                      class="titleTopShowToUSerNAme"
                      style="width: 90%"
                    ></div>
                  </div>
                </div>
              </div>

              <div v-if="!following.loading && following.list.length > 0">
                <div
                  class="userThumb"
                  v-for="(v, i) in following.list"
                  :key="i"
                  @click="profileRouteHandler(v)"
                >
                  <div class="userInfo">
                    <div class="userProfile">
                      <img :src="v.avatar" alt="" />
                    </div>
                    <div class="userName">{{ v.nickname }}</div>
                  </div>
                  <div
                    class="userBtn"
                    v-if="userInforamtion && userInforamtion.uid != v.uid"
                  >
                    <div
                      class="followBtn unfollowBtn"
                      v-if="!follow_btn_loading[i]"
                      @click.stop="follow(v.uid, i, 'unfollow')"
                    >
                      لغو دنبال کردن
                    </div>
                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="following.list.length === 0 && !following.loading"
                class="no-result"
              >
                <p>دنبال شونده ای یافت نشد</p>
              </div>

              <!-- Loading indicator برای lazy loading -->
              <div v-if="following.lazyLoading" class="lazy-loading-indicator">
                <div class="loading-spinner"></div>
                <p>در حال بارگذاری...</p>
              </div>
            </el-scrollbar>

            <!--            follower-->
            <el-scrollbar
              v-show="selectedFollow == 'follower'"
              class="usersList followerList"
              :height="followListHeight"
            >
              <div v-if="follower.loading && follower.list.length == 0">
                <div v-for="n in 3" :key="n" class="skeleton-wrapper">
                  <div class="TopShowToUSerNAme">
                    <div class="ImageTopShowToUSerNAme"></div>
                    <div
                      class="titleTopShowToUSerNAme"
                      style="width: 90%"
                    ></div>
                  </div>
                </div>
              </div>

              <div v-if="!follower.loading && follower.list.length > 0">
                <div
                  class="userThumb"
                  v-for="(v, i) in follower.list"
                  :key="i"
                  @click="profileRouteHandler(v)"
                >
                  <div class="userInfo">
                    <div class="userProfile">
                      <img :src="v.avatar" alt="" />
                    </div>
                    <div class="userName">{{ v.nickname }}</div>
                  </div>
                  <div
                    class="userBtn"
                    v-if="userInforamtion && userInforamtion.uid != v.uid"
                  >
                    <div
                      class="followBtn"
                      v-if="!v.isfollowing && !follow_btn_loading[i]"
                      @click.stop="follow(v.uid, i, 'follow')"
                    >
                      دنبال کردن
                    </div>
                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                    <div
                      class="followBtn unfollowBtn"
                      v-if="!follow_btn_loading[i] && v.isfollowing"
                      @click.stop="follow(v.uid, i, 'unfollow')"
                    >
                      لغو دنبال کردن
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="follower.list.length === 0 && !follower.loading"
                class="no-result"
              >
                <p>دنبال کننده ای یافت نشد</p>
              </div>

              <!-- Loading indicator برای lazy loading -->
              <div v-if="follower.lazyLoading" class="lazy-loading-indicator">
                <div class="loading-spinner"></div>
                <p>در حال بارگذاری...</p>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </el-dialog>

    <NewStory
      v-if="newStory"
      @close="storyCloseHandler"
      :BranchInfos="branch_infos"
    ></NewStory>
    <StorySlide
      v-if="storyOpen"
      :users="userStory"
      :userEdit="true"
      :userIndex="0"
      :isOpen="isDialogOpen"
      :isClose="closeDialog"
      :loadStory="load_story"
      :removeStory="removeStory"
      :isBackAction="storyBackAction"
      @close="closeDialog"
      @update-back-action="(val) => (storyBackAction = val)"
    />
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
// import DatePicker from "@alireza-ab/vue3-persian-datepicker";
import CreateMelk from "@/components/profile/createMelk";
import ShowFile from "@/components/profile/ShowFile";
import { Skeletor } from "vue-skeletor";
import MyAdvisors from "@/components/profile/MyAdvisors";
import PhoneBook from "@/components/profile/PhoneBook";
import ShowRent from "@/components/profile/ShowRent";
import buySubscribtion from "@/components/profile/buySubscribtion";
import NoteBook from "@/components/profile/noteBook";
import NewStory from "@/components/profile/NewStory";
import userSubscribtion from "@/components/profile/userSubscribtion";
import MyArchive from "@/components/profile/myArchive";
// import contractArchive from "@/components/profile/contractArchive.vue";
import createContract from "@/components/profile/createContract.vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
// import Compressor from "compressorjs";
import axios from "axios";
import StorySlide from "@/components/storySlide/StorySlide.vue";
import myNotif from "@/components/profile/myNotif.vue";
import requestVisit from "@/components/profile/requestVisit.vue";
import userTariff from "@/components/profile/userTariff.vue";
import L from "leaflet";
import "leaflet.markercluster";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";

try {
  if (maplibregl) {
    maplibregl.setRTLTextPlugin("./js/mapbox-gl-rtl-text.js", null, true);
  }
} catch (_e) {
  console.error(_e);
}

export default {
  name: "amlakProfile",
  components: {
    NewStory,
    NoteBook,
    PhoneBook,
    MyAdvisors,
    ShowFile,
    CreateMelk,
    Skeletor,
    ShowRent,
    buySubscribtion,
    userSubscribtion,
    // DatePicker,
    createContract,
    StorySlide,
    MyArchive,
    myNotif,
    requestVisit,
    userTariff,
  },
  data() {
    return {
      // نقشه‌ها
      map: null,
      leafletMap: null,
      mapInitialized: false,
      mapInitStarted: false,
      modalOpenWatcher: null,
      marker: null,
      center: { latitude: 36.5663854, longitude: 52.6707147 },
      defaultCenter: [36.5663854, 52.6707147],
      defaultZoom: 14,
      isLoading: true,
      followListHeight: "50vh",
      userInforamtion: null,
      selectedFollow: "",
      isFilterOpen: false,
      newStory: false,
      isBackAction: false,
      branch_list: [],
      left_menu: {
        CreateMelk: false,
        createContract: false,
        ShowFile: false,
        ShowRent: false,
        MyAdvisors: false,
        buySubscribtion: false,
        PhoneBook: false,
        NoteBook: false,
        contractArchive: false,
        MyArchive: false,
        myNotif: false,
        VisitRequest: false,
        userSubscribtion: false,
        userTariff: false,
      },
      compOpen: false,
      btn_loading: false,
      LoadingSkeleton: true,
      imageSrc: null,
      avatarFile: null,
      branch_infos: [],
      branch_info: {
        avatar: "",
        uid: this.$store.state.auth.uid,
        role: this.$store.state.auth.role,
        fname: this.$store.state.auth.fname,
        lname: this.$store.state.auth.lname,
        title: "",
        mobile: this.$store.state.auth.mobile,
        contact: "",
        code: "",
        code_melli: this.$store.state.auth.code_melli,
        javaz_expert: "",
        sabeghe: "",
        address: "",
        latlng: "",
        instagram: "",
        telegram: "",
        whatsup: "",
        b_category_id: "",
        lat: "",
        lng: "",
        mapAddress: "",
        description: "",
      },
      color: "",
      userStory: [],
      isDialogOpen: false,
      storyOpen: false,
      storyBackAction: false,
      follower: {
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        LoadingSkeleton: true,
      },
      following: {
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        LoadingSkeleton: true,
      },
      follow_btn_loading: [],
      scrollEl: null,
      editStyle: "padding: 0 30px; padding-bottom: 30px;",
      editHeight: "70vh",
      visitStatChecked: false,
      requestStatLaoing: false,
      currentUserInfo: null,
      userTariff: null,
    };
  },
  computed: {
    showFollowed() {
      return this.selectedFollow !== "";
    },
    ShowModel() {
      return this.$route.query.upadte === "active";
    },
  },
  methods: {
    buySubscribtionHandler() {
      history.back();
      window.location.reload();
      toast("اشتراک باموفقیت خریداری شد", {
        type: "success",
        dangerouslyHTMLString: true,
      });
    },
    onlyNumbers(event, field) {
      this.branch_info[field] = event.target.value.replace(/[^0-9]/g, "");
    },
    handleToggle() {
      const toggleValue = this.visitStatChecked ? 1 : 0;
      this.requestStatLaoing = true;
      this.helperPost("change-visit-request", {
        request_visit: toggleValue,
      })
        .then((response) => {
          console.log(response);
          if (toggleValue == 1) {
            toast("امکان ثبت درخواست بازدید برای آگهی های شما فعال شد", {
              type: "success",
            });
          } else {
            toast("امکان ثبت درخواست بازدید برای آگهی های شما غیرفعال شد", {
              type: "success",
            });
            this.visitStatChecked = false;
          }
          this.requestStatLaoing = false;
        })
        .catch((error) => {
          console.error(error);
          toast("مشکلی پیش آمده؛ مجددا امتحان کنید.", { type: "error" });
          this.visitStatChecked = false; // به جای $refs
          this.requestStatLaoing = false;
        });
    },
    editStyleHandler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        this.editStyle = "padding: 0 16px; padding-bottom: 24px;";
        this.editHeight = "90vh";
      }
    },
    handleFollowHeight() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        this.followListHeight = "calc(100vh - 150px)";
      }
    },
    follow(target_id, i, state) {
      var user_id = this.$store.state.auth.uid;
      this.follow_btn_loading[i] = true;
      this.helperPost("follow", {
        uid: user_id,
        target_id: target_id,
      }).then((r) => {
        console.log(r);
        if (state == "unfollow") {
          this.following.list.splice(i, 1);
          this.$store.state.auth.following--;
          this.follower.list[i].isfollowing = 0;
        } else {
          this.follower.list[i].isfollowing = 1;
          this.$store.state.auth.following++;
        }
        this.follow_btn_loading[i] = false;
        this.getCustomerinfo();
      });
    },

    getCustomerinfo() {
      this.helperPost("current-user-info").then((r) => {
        if (r.data.result == "1") {
          this.$store.commit("setAuth", r.data);
          this.$store.dispatch("checkAuth");
          this.currentUserInfo = r.data;
          // دیگه نیازی به setTimeout و $refs نیست
          this.visitStatChecked = r.data.request_visit == 1;
        }
      });
    },
    // handleScroll() {
    //   const scrollbar = document.querySelector(".usersList");
    //   if (
    //     !scrollbar ||
    //     this.follower.lazyLoading ||
    //     !this.follower.hasMorePages
    //   )
    //     return;

    //   const scrollPosition = scrollbar.scrollTop + scrollbar.clientHeight;
    //   const scrollHeight = scrollbar.scrollHeight;

    //   if (scrollPosition >= scrollHeight * 0.9) {
    //     this.loadMore();
    //   }
    // },
    handleScroll(e) {
      const target = e.target;
      let currentState =
        this.selectedFollow === "follower" ? this.follower : this.following;

      if (!target || currentState.lazyLoading || !currentState.hasMorePages)
        return;

      const scrollPosition = target.scrollTop + target.clientHeight;
      const scrollHeight = target.scrollHeight;

      if (scrollPosition >= scrollHeight - 10) {
        if (this.selectedFollow === "follower") {
          this.loadMoreFollower();
        } else {
          this.loadMoreFollowing();
        }
      }
    },

    async loadMoreFollower() {
      if (this.follower.hasMorePages && !this.follower.lazyLoading) {
        this.follower.lazyLoading = true;
        this.follower.page++;
        await this.getfollower();
        this.follower.lazyLoading = false;
      }
    },

    async loadMoreFollowing() {
      if (this.following.hasMorePages && !this.following.lazyLoading) {
        this.following.lazyLoading = true;
        this.following.page++;
        await this.getfollowing();
        this.following.lazyLoading = false;
      }
    },

    attachScrollEvent() {
      this.$nextTick(() => {
        // ابتدا event قبلی رو detach کن
        this.detachScrollEvent();

        let selector =
          this.selectedFollow === "follower"
            ? ".followerList .el-scrollbar__wrap"
            : ".followingList .el-scrollbar__wrap";

        const el = this.$el.querySelector(selector);
        if (el) {
          this.scrollEl = el;
          el.addEventListener("scroll", this.handleScroll);
        }
      });
    },

    detachScrollEvent() {
      if (this.scrollEl) {
        this.scrollEl.removeEventListener("scroll", this.handleScroll);
        this.scrollEl = null;
      }
    },

    // async loadMore() {
    //   if (this.follower.hasMorePages && !this.follower.lazyLoading) {
    //     this.follower.lazyLoading = true;
    //     this.follower.page++;
    //     await this.getfollower();
    //     this.follower.lazyLoading = false;
    //   }
    // },
    getfollower: function () {
      let self = this;
      // فقط برای صفحه اول loading رو true کن
      if (self.follower.page === 1) {
        this.follower.loading = true;
      }
      self.follower.hasMorePages = false;
      // این خط رو حذف کردیم که باعث پاک شدن لیست میشد
      // self.following.list = [];
      this.helperPost("followers-list", { page: self.follower.page })
        .then(function (r) {
          const result = r.data;
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.follower.page);
            if (currentPage > 1) {
              // برای صفحات بعدی، لیست رو به انتهای لیست موجود اضافه کن
              self.follower.list = [...self.follower.list, ...list];
            } else {
              // فقط برای صفحه اول، لیست رو جایگزین کن
              const scrollbar = document.querySelector(".usersList");
              if (scrollbar) scrollbar.scrollTop = 0;

              self.follower.list = list;
            }

            self.follow_btn_loading = new Array(self.follower.list.length).fill(
              false,
            );

            self.follower.hasMorePages = currentPage < totalPage;
          } else {
            self.follower.hasMorePages = false;
          }
          self.follower.loading = false;

          console.log("self.follower.list", self.follower.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.follower.loading = false;
          self.follower.hasMorePages = false;
        });
    },

    getfollowing: function () {
      let self = this;
      // فقط برای صفحه اول loading رو true کن
      if (self.following.page === 1) {
        this.following.loading = true;
      }
      self.following.hasMorePages = false;
      // این خط رو حذف کردیم که باعث پاک شدن لیست میشد
      // self.follower.list = [];
      this.helperPost("following-list", { page: self.following.page })
        .then(function (r) {
          const result = r.data;
          console.log("result", result);
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.following.page);
            console.log("ist0", list);
            if (currentPage > 1) {
              console.log("ist1", list);
              // برای صفحات بعدی، لیست رو به انتهای لیست موجود اضافه کن
              self.following.list = [...self.following.list, ...list];
            } else {
              // فقط برای صفحه اول، لیست رو جایگزین کن
              const scrollbar = document.querySelector(".usersList");
              if (scrollbar) scrollbar.scrollTop = 0;

              console.log("ist", list);
              self.following.list = list;
            }

            self.follow_btn_loading = new Array(
              self.following.list.length,
            ).fill(false);

            self.following.hasMorePages = currentPage < totalPage;
          } else {
            self.following.hasMorePages = false;
          }
          self.following.loading = false;

          console.log("self.following.list", self.following.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.following.loading = false;
          self.following.hasMorePages = false;
        });
    },

    selectedFollowClose(btn = false) {
      let self = this;
      if (!this.isBackAction && btn) {
        history.back();
      }

      setTimeout(() => {
        // Reset کردن همه state ها
        self.follower.list = [];
        self.following.list = [];
        self.follower.page = 1;
        self.following.page = 1;
        self.follower.hasMorePages = true;
        self.following.hasMorePages = true;
        self.follower.loading = false;
        self.following.loading = false;
        self.follower.lazyLoading = false;
        self.following.lazyLoading = false;
        self.selectedFollow = "";
      }, 500);
    },
    selectedFollowHandler(state, first = false) {
      this.selectedFollow = state;
      if (first) {
        history.pushState(null, "", location.href);
      }
      // API فراخوانی رو حذف کردیم چون در watch انجام میشه
    },
    load_story() {
      axios
        .get(
          this.$store.getters.baseUrl +
            "/get-story?branch_id=" +
            this.branch_infos.id,
        )
        .then((r) => {
          if (r.data.result == 0) {
            this.userStory = [];
          } else {
            this.userStory = r.data.data;
          }
        });
    },
    openDialog() {
      this.isDialogOpen = true;
      this.storyOpen = true;
      document.body.style.overflow = "hidden";
      history.pushState(null, "", location.href);
    },
    closeDialog() {
      if (!this.storyBackAction) {
        history.back();
      }
      this.isDialogOpen = false;
      this.storyOpen = false;
      document.body.style.overflow = "auto";
    },
    removeStory(userIndex, storyIndex) {
      if (
        this.users[userIndex] &&
        this.users[userIndex].stories &&
        this.users[userIndex].stories[storyIndex]
      ) {
        this.users[userIndex].stories.splice(storyIndex, 1);
      }
    },
    profileRouteHandler(user) {
      if (user.role == "branch_admin") {
        this.$router.push({
          path: "/profile-amlak",
          query: { bid: user.branch_id },
        });
      } else if (user.role == "builder") {
        this.$router.push({
          path: "/profile-builder",
          query: { uid: user.uid },
        });
      } else
        this.$router.push({
          path: "/profile-superior",
          query: { uid: user.uid },
        });
    },
    loadTheme() {
      const width = window.innerWidth;
      this.color = width >= 1250 ? "#0096c7" : "#f5f5f5";
    },
    checkDocumentReady() {
      return new Promise((resolve) => {
        if (document.readyState === "complete") {
          resolve();
        } else {
          window.addEventListener("load", resolve, { once: true });
        }
      });
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    // async previewImage(event) {
    //   var self = this;
    //   const file = event.target.files[0];
    //   if (!file) {
    //     return;
    //   }
    //   const reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.imageSrc = e.target.result;
    //   };
    //   reader.readAsDataURL(file);

    //   new Compressor(file, {
    //     quality: 0.6,

    //     // The compression process is asynchronous,
    //     // which means you have to access the `result` in the `success` hook function.
    //     success(result) {
    //       const formData = new FormData();

    //       // The third parameter is required for server

    //       formData.append("from", "branch");
    //       //formData.append("token", self.$store.getters.appToken);
    //       formData.append("uid", self.$store.state.auth.uid);
    //       formData.append("avatar", result);

    //       axios
    //         .post(self.$store.getters.baseUrl + "/upload-avatar", formData, {
    //           headers: {
    //             "Content-Type": "multipart/form-data",
    //             Authorization: "Bearer " + self.$store.getters.appToken,
    //           },
    //         })
    //         .then(function (response) {
    //           console.log("response", response);
    //           if (response.data.result == "1") {
    //             toast(response.data.msg, {
    //               type: "success",
    //               dangerouslyHTMLString: true,
    //             });
    //             self.get_branch_info();
    //             self.ShowModel = false;
    //           } else {
    //             toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
    //               type: "error",
    //               dangerouslyHTMLString: true,
    //             });
    //           }
    //         });
    //     },
    //     error(err) {
    //       console.log(err.message);
    //     },
    //   });
    // },
    previewImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.avatarFile = file; // فایل رو نگه می‌داریم
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    // removeImage() {
    //   var self = this;
    //   self.imageSrc = null;
    //   self.$refs.fileInput.value = "";
    //   self.$swal
    //     .fire({
    //       title: "حذف تصویر پروفایل",
    //       text: "آیا از حذف تصویر پروفایل مطمئن هستید؟",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#0096c7",
    //       cancelButtonColor: "#fff",
    //       confirmButtonText: "بله مطمئنم",
    //       cancelButtonText: "لغو",
    //     })
    //     .then((result) => {
    //       if (result.isConfirmed) {
    //         if (result.value) {
    //           self
    //             .helperGet(
    //               "delete-avatar",
    //               "from=branch&uid=" + self.$store.state.auth.uid
    //             )
    //             .then((r) => {
    //               if (r.data.result == "1") {
    //                 toast(r.data.msg, {
    //                   type: "success",
    //                   dangerouslyHTMLString: true,
    //                 });
    //                 self.imageSrc = null;
    //                 self.$refs.fileInput.value = "";
    //                 self.get_branch_info();
    //                 self.ShowModel = false;
    //               }
    //             });
    //         }
    //       }
    //     });
    // },
    removeImage() {
      this.avatarFile = null;
      this.imageSrc = null;
      this.branch_infos.avatar = ""; // حذف کامل
      this.branch_info.avatar = "";
      if (this.branch_infos) {
        this.branch_infos.has_avatar = false;
      }
      this.$refs.fileInput.value = "";
    },
    // reloadPage() {
    //   setTimeout(() => {
    //     this.checkDocumentReady().then(() => {
    //       this.LoadingSkeleton = false; // غیرفعال کردن اسکلت loading
    //     });
    //   }, 200);
    // },
    Logout() {
      this.$swal
        .fire({
          title: "خروج از حساب کاربری",
          text: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "خروج",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("logout")
                .then((r) => {
                  if (r.data.success == true) {
                    this.$store.state._token = "";
                    this.$store.getters.auth.loggedIn = false;
                    // this.$store.state.c_set = [];
                    localStorage.removeItem("_token");
                    localStorage.removeItem("auth");
                    this.$router.push({ path: "/home" });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },

    load_district() {
      let self = this;
      this.helperGet("system-cat", "type=branch").then((r) => {
        console.log("datattt:" + r.data.data);
        self.branch_list = r.data.data;
      });
    },

    async get_branch_info() {
      await this.helperGet("branch-infos").then((res) => {
        if (res.data.result == "1") {
          this.branch_infos = res.data.data;
          res.data.data.has_avatar
            ? (this.imageSrc =
                this.$store.state.auth.role == "branch_admin"
                  ? res.data.data.avatar
                  : res.data.data.user_avatar)
            : "";
          this.branch_info.avatar = res.data.data.has_avatar
            ? res.data.data.avatar
            : "";
          this.branch_info.title = res.data.data.title;
          this.branch_info.contact = res.data.data.contact;
          this.branch_info.code = res.data.data.code;
          this.branch_info.sabeghe = res.data.data.sabeghe;
          this.branch_info.javaz_expert = res.data.data.javaz_expert;
          this.branch_info.address = res.data.data.address;
          this.branch_info.lat = res.data.data.lat;
          this.branch_info.lng = res.data.data.lng;
          this.branch_info.instagram = res.data.data.instagram;
          this.branch_info.telegram = res.data.data.telegram;
          this.branch_info.whatsup = res.data.data.whatsup;
          this.branch_info.description = res.data.data.details;
          this.branch_info.b_category_id = res.data.data.b_category_id;
          this.LoadingSkeleton = false;
          this.load_story();
          // this.show_file = true;
        }
        this.LoadingSkeleton = false;
      });
      localStorage.setItem("branchinof", JSON.stringify(this.branch_infos));
    },
    //async send_edit_data() {
    //  if (
    //    !this.avatarFile &&
    //    !this.branch_info.avatar &&
    //    !(this.branch_infos && this.branch_infos.has_avatar)
    //  ) {
    //    toast("تصویر پروفایل خود را آپلود کنید", { type: "error" });
    //    return;
    //  } else if (this.branch_info.fname == "") {
    //    toast("نام خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (this.branch_info.lname == "") {
    //    toast("نام خانوادگی خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (
    //    this.branch_info.title == "" &&
    //    this.$store.state.auth.role != "consultant"
    //  ) {
    //    toast("نام املاک خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (
    //    this.branch_info.code == "" &&
    //    this.$store.state.auth.role != "consultant"
    //  ) {
    //    toast("کد اتحادیه خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (this.branch_info.code_melli == "") {
    //    toast("کد ملی خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (
    //    this.branch_info.b_category_id == "" &&
    //    this.$store.state.auth.role != "consultant"
    //  ) {
    //    toast("منطقه خود را انتخاب کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (
    //    this.branch_info.mobile == "" &&
    //    this.$store.state.auth.role != "consultant"
    //  ) {
    //    toast("شماره تماس خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (
    //    this.branch_info.address == "" &&
    //    this.$store.state.auth.role != "consultant"
    //  ) {
    //    toast("آدرس خود را وارد کنید", {
    //      type: "error",
    //    });
    //    return;
    //  } else if (
    //    this.branch_info.lat == "" &&
    //    this.branch_info.lng == "" &&
    //    this.$store.state.auth.role != "consultant"
    //  ) {
    //    toast("موقعیت مکانی خود را انتخاب کنید", {
    //      type: "error",
    //    });
    //    return;
    //  }
    //
    //  this.btn_loading = true;
    //  var avatarStatus = 0;
    //
    //  try {
    //    if (this.avatarFile) {
    //      const formData = new FormData();
    //
    //      formData.append("avatar", this.avatarFile);
    //      formData.append("uid", this.$store.state.auth.uid);
    //      formData.append("from", this.$store.state.auth.role);
    //
    //      const avatarResponse = await fetch(
    //        this.$store.getters.baseUrl + "/upload-avatar",
    //        {
    //          method: "POST",
    //          headers: {
    //            Authorization:
    //              "Bearer " + this.$store.getters.appToken,
    //          },
    //          body: formData,
    //        }
    //      );
    //
    //      const avatarRes = await avatarResponse.json();
    //
    //      if (avatarRes.result == "1") {
    //        avatarStatus = 1;
    //      } else {
    //        toast(avatarRes.msg, { type: "error" });
    //        this.btn_loading = false;
    //        return;
    //      }
    //    }
    //
    //    const r = await this.helperPost(
    //      "update-profile",
    //      this.branch_info
    //    );
    //
    //    if (r.data.result == "1") {
    //      toast(r.data.msg, {
    //        type: "success",
    //        dangerouslyHTMLString: true,
    //      });
    //
    //      this.get_branch_info();
    //      this.getCustomerinfo();
    //      this.destroyMap();
    //      history.back();
    //    } else {
    //      toast(r.data.msg, {
    //        type: "error",
    //        dangerouslyHTMLString: true,
    //      });
    //
    //      if (avatarStatus == 1) {
    //        this.get_branch_info();
    //      }
    //    }
    //  } catch (error) {
    //    console.error(error);
    //
    //    toast("مشکلی پیش آمده. مجدد تلاش کنید!", {
    //      type: "error",
    //    });
    //  } finally {
    //    this.btn_loading = false;
    //  }
    //},
    async send_edit_data() {
      if (
        !this.avatarFile &&
        !this.branch_info.avatar &&
        !(this.branch_infos && this.branch_infos.has_avatar)
      ) {
        toast("تصویر پروفایل خود را آپلود کنید", { type: "error" });
        return;
      } else if (this.branch_info.fname == "") {
        toast("نام خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (this.branch_info.lname == "") {
        toast("نام خانوادگی خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.branch_info.title == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("نام املاک خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.branch_info.code == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("کد اتحادیه خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (this.branch_info.code_melli == "") {
        toast("کد ملی خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.branch_info.b_category_id == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("منطقه خود را انتخاب کنید", {
          type: "error",
        });
        return;
      } else if (
        this.branch_info.mobile == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("شماره تماس خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.branch_info.address == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("آدرس خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.branch_info.lat == "" &&
        this.branch_info.lng == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("موقعیت مکانی خود را انتخاب کنید", {
          type: "error",
        });
        return;
      }

      this.btn_loading = true;
      var avatarStatus = 0;
      try {
        if (this.avatarFile) {
          // const compressed = await new Promise((resolve, reject) => {
          //   new Compressor(this.avatarFile, {
          //     quality: 0.6,
          //     success: (result) => resolve(result),
          //     error: (err) => reject(err),
          //   });
          // });
          const formData = new FormData();

          formData.append("avatar", this.avatarFile);
          formData.append("uid", this.$store.state.auth.uid);
          formData.append("from", this.$store.state.auth.role);

          const avatarRes = await axios.post(
            this.$store.getters.baseUrl + "/upload-avatar",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + this.$store.getters.appToken,
              },
            },
          );

          if (avatarRes.data.result == "1") {
            avatarStatus = 1;
          } else {
            toast(avatarRes.data.msg, { type: "error" });
            this.btn_loading = false;
            return;
          }
        }

        const r = await this.helperPost("update-profile", this.branch_info);

        if (r.data.result == "1") {
          toast(r.data.msg, {
            type: "success",
            dangerouslyHTMLString: true,
          });
          this.get_branch_info();
          this.getCustomerinfo();
          this.destroyMap();
          history.back();
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
          if (avatarStatus == 1) {
            this.get_branch_info();
          }
        }
      } catch (error) {
        console.error(error);
        toast("خطایی در ارتباط با سرور رخ داد", { type: "error" });
      } finally {
        this.btn_loading = false;
      }
    },
    // send_edit_data() {
    //   if (!this.avatarFile && !this.branch_info.avatar) {
    //     toast("تصویر پروفایل خود را آپلود کنید", { type: "error" });
    //     return;
    //   } else if (this.branch_info.fname == "") {
    //     toast("نام خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.lname == "") {
    //     toast("نام خانوادگی خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.title == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("نام املاک خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.code == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("کد اتحادیه خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.code_melli == "") {
    //     toast("کد ملی خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.b_category_id == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("منطقه خود را انتخاب کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.mobile == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("شماره تماس خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.address == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("آدرس خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.branch_info.mapAddress == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("موقعیت مکانی خود را انتخاب کنید", {
    //       type: "error",
    //     });
    //     return;
    //   }
    //   this.btn_loading = true;
    //   this.helperPost("update-profile", this.branch_info).then((r) => {
    //     console.log("sdsd", r);
    //     if (r.data.result == "1") {
    //       toast(r.data.msg, {
    //         type: "success",
    //         dangerouslyHTMLString: true,
    //       });
    //       this.get_branch_info();
    //       this.getCustomerinfo()
    //       this.ShowModel = false;
    //     } else {
    //       toast(r.data.msg, {
    //         type: "error",
    //         dangerouslyHTMLString: true,
    //       });
    //     }
    //     this.btn_loading = false;
    //   });
    // },

    profileEditHadler() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ["upadte"]: "active",
        },
      });
    },

    profileCloseHandler() {
      history.back();
    },

    storyOpenHandler() {
      this.$router.push("/profile/newStory");
    },

    storyCloseHandler() {
      history.back();
      this.newStory = false;
      this.load_story();
    },
    openComponent(menuKey) {
      if (menuKey == "CreateMelk") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت آگهی وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "buySubscribtion") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای خرید اشتراک وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای خرید اشتراک اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای خرید اشتراک نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای خرید اشتراک اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "PhoneBook") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت مخاطب وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت مخاطب اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت مخاطب نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت مخاطب اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "NoteBook") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت متقاضی وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت متقاضی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت متقاضی نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت متقاضی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "MyArchive") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای مشاهده بایگانی فایل ها وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده بایگانی فایل ها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              },
            );
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای مشاهده بایگانی فایل ها نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده بایگانی فایل ها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              },
            );
            return;
          }
        }
      } else if (menuKey == "ShowFile") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای مشاهده آگهی های من وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای مشاهده آگهی های من اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای مشاهده آگهی های من نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای مشاهده آگهی های من اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "createContract") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت قراردادها وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت قراردادها اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت قراردادها نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت قراردادها اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "ShowRent") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای مشاهده لیست قراردادها وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده لیست قراردادها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              },
            );
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای مشاهده لیست قراردادها نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده لیست قراردادها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              },
            );
            return;
          }
        }
      } else if (menuKey == "MyAdvisors") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای افزودن مباشر وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای افزودن مباشر اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای افزودن مباشر نیاز است هویت شما تایید شود.",
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای افزودن مباشر اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (menuKey == "userTariff") {
        const title =
          this.$store.state.auth.role == "branch_admin"
            ? "مدیریت تعرفه"
            : "خرید تعرفه";
        if (!this.$store.state.auth.loggedIn) {
          toast(`برای ${title} وارد حساب کاربری خود شوید`, {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(`برای ${title} اطلاعات پروفایل خود را تکمیل کنید`, {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branch_infos &&
            this.branch_infos.is_allowed != "active"
          ) {
            toast(
              `پروفایل شما تکمیل شده است، اما برای ${title} نیاز است هویت شما تایید شود.`,
              {
                type: "error",
              },
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(`برای ${title} اطلاعات پروفایل خود را تکمیل کنید`, {
              type: "error",
            });
            return;
          }
        }
      }
      // this.left_menu[menuKey] = true;
      // history.pushState(null, "", location.href);
      // document.body.style.overflowY = "hidden";
      this.$router.push(`/profile/${menuKey}`);
    },
    closeComponent(menuKey) {
      if (!this.isBackAction) {
        history.back();
      }
      this.left_menu[menuKey] = false;
      document.body.style.overflowY = "auto";
    },
    // handleBackButton() {
    //   let windowWidth = window.innerWidth;
    //   if (this.ShowModel && windowWidth < 700) {
    //     this.ShowModel = false;
    //     return;
    //   }
    //   if (this.newStory && windowWidth < 700) {
    //     this.newStory = false;
    //     return;
    //   }
    //   if (this.selectedFollow != "") {
    //     this.selectedFollowClose();
    //     return;
    //   }
    //   if (this.isFilterOpen) {
    //     return;
    //   }
    //   const isAnyOpen = Object.values(this.left_menu).some(
    //     (val) => val === true
    //   );
    //   if (isAnyOpen) {
    //     this.isBackAction = true;
    //     Object.keys(this.left_menu).forEach((key) => {
    //       this.left_menu[key] = false;
    //     });
    //     document.body.style.overflowY = "auto";
    //     this.isBackAction = false;
    //   }
    // },
    initMap() {
      this.isLoading = true;
      this.destroyMap();

      this.initLeafletPicker();
    },

    /* ================== Leaflet picker ================== */
    initLeafletPicker() {
      try {
        const container =
          this.$refs.mapContainer || document.getElementById("map");
        if (!container) {
          console.error("Leaflet map container not found");
          this.isLoading = false;
          return;
        }

        // رفع آیکون پیش‌فرض Leaflet در build
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        });

        let center = this.defaultCenter;
        if (this.branch_info && this.branch_info.lat && this.branch_info.lng) {
          center = [
            parseFloat(this.branch_info.lat),
            parseFloat(this.branch_info.lng),
          ];
        }

        const mapirToken =
          this.$store.state.c_set?.map_info?.mapir_key ||
          this.$store.state.c_set?.mapir_key ||
          "";

        this.leafletMap = L.map(container, {
          center,
          zoom: this.defaultZoom,
          maxZoom: 19,
        });
        this.map = this.leafletMap;

        if (mapirToken) {
          L.maplibreGL({
            style:
              "https://map.ir/vector/styles/main/mapir-xyz-style.json?x-api-key=" +
              mapirToken,
            transformRequest: (url) => {
              return {
                url: url,
                headers: { "x-api-key": mapirToken },
              };
            },
            attribution:
              '<span dir="ltr">© <a href="https://map.ir">map.ir</a></span>',
            maxZoom: 19,
          }).addTo(this.leafletMap);
        } else {
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 20,
            minZoom: 5,
            attribution: "© OpenStreetMap",
          }).addTo(this.leafletMap);
        }

        this.marker = L.marker(center, { draggable: false }).addTo(
          this.leafletMap,
        );

        this.leafletMap.on("click", this.handleMapClickLeaflet);

        setTimeout(() => {
          try {
            this.leafletMap.invalidateSize();
          } catch (e) {
            console.log(e);
          }
        }, 100);
      } catch (error) {
        console.error("Error initializing Leaflet picker:", error);
      } finally {
        this.isLoading = false;
      }
    },

    handleMapClickLeaflet(e) {
      try {
        const { lat, lng } = e.latlng;
        this.branch_info.lat = lat;
        this.branch_info.lng = lng;

        if (this.marker) {
          this.marker.setLatLng([lat, lng]);
        } else {
          this.marker = L.marker([lat, lng], { draggable: false }).addTo(
            this.leafletMap,
          );
        }

        // آپدیت آدرس
        this.updateAddress(lat, lng);

        console.log(`Leaflet clicked at: ${lat}, ${lng}`);
      } catch (err) {
        console.error("handleMapClickLeaflet error:", err);
      }
    },

    /* ================== آدرس از map.ir ================== */
    async updateAddress(lat, lng) {
      try {
        const mapirToken =
          this.$store.state.c_set?.map_info?.mapir_key ||
          this.$store.state.c_set?.mapir_key ||
          "";
        const url = `https://map.ir/reverse/?lat=${lat}&lon=${lng}`;

        const response = await axios.get(url, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-api-key": mapirToken,
          },
        });

        let persianAddress = "";

        if (response.data && response.data.address_compact) {
          persianAddress = response.data.address_compact;
        } else if (response.data && response.data.address) {
          persianAddress = response.data.address;
        }

        if (!persianAddress) persianAddress = "آدرس نامشخص";

        if (!this.branch_info) this.branch_info = {};
        this.branch_info.mapAddress = persianAddress;
        this.branch_info.address = persianAddress;
        this.branch_info.lat = Number(lat);
        this.branch_info.lng = Number(lng);
      } catch (err) {
        console.error("updateAddress error (map.ir):", err);
        if (!this.branch_info) this.branch_info = {};
        toast("خطا در دریافت آدرس", {
          type: "error",
        });
      }
    },

    /* ================== Cleanup ================== */
    destroyMap() {
      try {
        if (this.leafletMap) {
          this.leafletMap.off("click", this.handleMapClickLeaflet);
          this.leafletMap.remove();
          this.leafletMap = null;
          this.marker = null;
        }
      } catch (e) {
        console.error(e);
      }
      this.map = null;
      this.mapInitialized = false;
      this.mapInitStarted = false;
    },

    /* ================== utility ================== */
    handleMarkerDrag(event) {
      const position = event.target.getLatLng();
      this.updateAddress(position.lat, position.lng);
    },
    reloadComponent() {
      this.get_branch_info();
    },
  },
  watch: {
    showFollowed(val) {
      if (val) {
        this.attachScrollEvent();
      } else {
        this.detachScrollEvent();
      }
    },
    ShowModel(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.initMap();
        }, 500);
      } else {
        this.destroyMap();
      }
    },

    selectedFollow(val) {
      // وقتی تب عوض میشه، صفحه‌بندی رو reset کن و داده‌ها رو لود کن
      if (val === "follower") {
        this.follower.page = 1; // ریست کردن صفحه برای followers
        this.follower.list = []; // پاک کردن لیست قبلی
        this.follower.hasMorePages = true; // reset کردن hasMorePages
        this.getfollower(); // لود کردن داده‌ها
      } else if (val === "following") {
        this.following.page = 1; // ریست کردن صفحه برای following
        this.following.list = []; // پاک کردن لیست قبلی
        this.following.hasMorePages = true; // reset کردن hasMorePages
        this.getfollowing(); // لود کردن داده‌ها
      }

      this.detachScrollEvent();
      this.attachScrollEvent();
    },
    onImgError(e) {
      e.target.src = "/img/amlakLogo.jpg";
    },
    "$route.params": {
      handler() {
        const routePage = this.$route.params.page;
        if (routePage) {
          this.left_menu = {
            CreateMelk: false,
            createContract: false,
            ShowFile: false,
            ShowRent: false,
            MyAdvisors: false,
            buySubscribtion: false,
            PhoneBook: false,
            NoteBook: false,
            contractArchive: false,
            MyArchive: false,
            myNotif: false,
            VisitRequest: false,
            userSubscribtion: false,
            userTariff: false,
          };
          this.newStory = false;
          this.LoadingSkeleton = false;
          if (routePage == "newStory") {
            this.newStory = true;
          } else {
            this.left_menu[routePage] = true;
          }
        } else {
          this.left_menu = {
            CreateMelk: false,
            createContract: false,
            ShowFile: false,
            ShowRent: false,
            MyAdvisors: false,
            buySubscribtion: false,
            PhoneBook: false,
            NoteBook: false,
            contractArchive: false,
            MyArchive: false,
            myNotif: false,
            VisitRequest: false,
            userSubscribtion: false,
            userTariff: false,
          };
          this.newStory = false;
        }
      },
      immediate: true,
      deep: true,
    },
    "$store.state.c_set": {
      handler() {
        this.destroyMap();
        this.mapInitStarted = true;
        this.$nextTick(() => {
          if (!this.mapInitialized) {
            this.initMap();
          }
        });
      },
      immediate: true,
    },
  },
  async mounted() {
    if (this.$store.state.auth.loggedIn) {
      if (!this.$store.state.auth.is_complate) {
        toast("لطفا اطلاعات پروفایل خود را تکمیل کنید", {
          type: "warning",
        });
      }
    }
    const userRaw = localStorage.getItem("auth");
    this.userTariff = userRaw ? JSON.parse(userRaw)?.user_tariff || null : null;
    this.load_district();
    this.handleFollowHeight();
    this.editStyleHandler();
    this.$nextTick(() => {
      this.getCustomerinfo();
    });
    window.addEventListener("resize", function () {
      this.editStyleHandler;
      this.handleFollowHeight;
    });
    // window.addEventListener("resize", this.handleFollowHeight);
    // window.addEventListener("popstate", this.handleBackButton);
    this.userInforamtion = JSON.parse(localStorage.getItem("auth"));
    setInterval(() => {
      this.loadTheme();
    }, 100);
    // this.reloadPage();
    let role = this.$store.state.auth.role;
    let uid = this.$store.state.auth.uid;
    role == "customer" || role == "builder"
      ? this.$router.push({ path: "/profile-personal", query: { uid } })
      : "";
    let openShowFile = localStorage.getItem("openShowFile");
    let tComp = localStorage.getItem("tComp");
    if (openShowFile) {
      let info = JSON.parse(localStorage.getItem("branchinof"));
      this.branch_infos = info;
      if (tComp == "ShowFile") {
        this.left_menu.ShowFile = true;
      } else {
        this.left_menu.MyArchive = true;
      }
      this.LoadingSkeleton = false;
      this.$nextTick(() => {
        localStorage.removeItem("openShowFile");
        localStorage.removeItem("tComp");
      });
    } else {
      await this.get_branch_info();
    }
    let showFollow = localStorage.getItem("showFollow");
    if (showFollow) {
      this.selectedFollow = showFollow;
      this.LoadingSkeleton = false;
      this.$nextTick(() => {
        localStorage.removeItem("showFollow");
      });
    }
  },
  beforeMount() {
    // window.removeEventListener("popstate", this.handleBackButton);
  },
  beforeUnmount() {
    this.destroyMap();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 25px !important;
  height: 25px !important;
  margin-bottom: 5px;
}
.requestVisit {
  display: flex;
  align-items: center;
  gap: 4px;

  p {
    margin-bottom: 0 !important;
  }
}

.dark {
  .switchInput {
    input:checked + .slider {
      box-shadow:
        inset 0 0 4px rgba(255, 255, 255, 0.12),
        inset 0 3px 6px rgba(255, 255, 255, 0.15);
    }

    .slider {
      background: #20262c;
      box-shadow:
        inset 0 0 4px rgba(255, 255, 255, 0.07),
        inset 0 2px 4px rgba(255, 255, 255, 0.04),
        0 1px 1px rgba(0, 0, 0, 0.8);
    }
  }
}

.switchInput {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 26px;
  flex-shrink: 0;

  &.loading {
    pointer-events: none;
  }

  input {
    display: none;
  }

  input:checked + .slider {
    background: #0096c7;
    box-shadow:
      inset 0 0 4px rgba(0, 0, 0, 0.12),
      inset 0 3px 6px rgba(0, 0, 0, 0.15);

    &::before {
      transform: translateX(24px);
      background: #fff;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f6f6f4;
    border-radius: 50px;
    transition: 0.25s ease;
    box-shadow:
      inset 0 0 4px rgba(0, 0, 0, 0.07),
      inset 0 2px 4px rgba(0, 0, 0, 0.04),
      0 1px 1px rgba(255, 255, 255, 0.8);

    &::before {
      content: "";
      position: absolute;
      height: 20px;
      width: 20px;
      left: 3px;
      top: 3px;
      background: #ffffff;
      border-radius: 50%;
      transition: 0.25s ease;
      box-shadow:
        0 2px 4px rgba(0, 0, 0, 0.08),
        0 4px 8px rgba(0, 0, 0, 0.04);
    }
  }
}
@media (min-width: 700px) {
  .ShowInputFormToUser1 .ChildShowInputFormToUser {
    &.textareaWrapper {
      grid-column: span 2;
    }
  }
}

@media (max-width: 700px) {
  .creditSignSkeletor {
    margin-top: 0 !important;
  }

  .phoneclassSkeletor {
    margin-bottom: 10px !important;
    margin-top: 10px !important;
  }

  .PhoneClassNumber {
    &.addressProfile {
      align-items: center !important;
      margin: 0 !important;
      margin-bottom: 6px !important;

      p {
        margin-bottom: 0 !important;
      }

      &.requestVisit {
        margin-block: -4px 18px !important;
      }
    }
  }

  .container1 {
    .profileImageSkeletor {
      width: 94% !important;
      display: block !important;
      margin: 0 auto !important;
      margin-bottom: -16px !important;
    }

    .firstNameSkeletor,
    .mobileStatisticsSkeletor {
      display: none !important;
    }
  }
}

.editMapContainer {
  width: 100%;
  grid-column: span 2;
  padding-top: 16px;

  .containerLabel {
    margin-top: 15px;
    margin-bottom: 10px;
    margin-right: 10px;
    font-size: 1rem;
    color: #333;
    font-family: "iranyekanB";
  }

  .containerMap {
    width: 100%;
    height: 224px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    overflow: hidden;

    #map {
      width: 100%;
      height: 100%;
    }
  }
}

.dark {
  .editMapContainer {
    .containerLabel {
      color: #aaa;
      font-size: 0.85rem;
    }
  }
}

@media (max-width: 700px) {
  .editMapContainer {
    grid-column: span 1;
  }
}
</style>
